export default {"src":"/_next/static/media/google.4b9c82ae.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};